import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { slot: "label" }

import { IonButton, IonButtons, IonContent, IonFab, IonFabButton, IonHeader, IonIcon, IonInput, IonItem, IonList, IonText, IonTextarea, IonTitle, IonToolbar, modalController } from "@ionic/vue";
import { closeOutline, saveOutline } from "ionicons/icons";
import { translate } from '@hotwax/dxp-components';
import { onMounted, ref } from "vue";
import logger from "@/logger";
import { hasError, showToast } from "@/utils";
import { ChannelService } from '@/services/ChannelService'
import store from "@/store";
import emitter from "@/event-bus";


export default /*@__PURE__*/_defineComponent({
  __name: 'EditGroupModal',
  props: ["group"],
  setup(__props) {

const props = __props;
const formData = ref({
  facilityGroupName: "",
  description: ""
})

onMounted(() => {
  formData.value.facilityGroupName = props.group.facilityGroupName
  formData.value.description = props.group.description
})

function isGroupUpdated() {
  return formData.value.facilityGroupName !== props.group.facilityGroupName || formData.value.description !== props.group.description
}

async function updateGroup() {
  if (!formData.value.facilityGroupName?.trim()) {
    showToast(translate("Please fill in all the required fields."))
    return;
  }

  emitter.emit("presentLoader");
  try {
    const resp = await ChannelService.updateGroup({...formData.value, facilityGroupId: props.group.facilityGroupId})

    if(!hasError(resp)) {
      store.dispatch("channel/updateGroup", { facilityGroupId: props.group.facilityGroupId, ...formData.value })
      showToast(translate("Group updated successfully."))
      modalController.dismiss();
    } else {
      throw resp.data;
    }
  } catch(err) {
    showToast(translate("Failed to update group."))
    logger.error(err);
  }
  emitter.emit("dismissLoader");
}

function closeModal() {
  modalController.dismiss();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (closeModal()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      slot: "icon-only",
                      icon: _unref(closeOutline)
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonTitle), null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(translate)("Edit channel group")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonList), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonItem), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonInput), {
                  labelPlacement: "floating",
                  modelValue: formData.value.facilityGroupName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.facilityGroupName) = $event))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createTextVNode(_toDisplayString(_unref(translate)("Name")) + " ", 1),
                      _createVNode(_unref(IonText), { color: "danger" }, {
                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                          _createTextVNode("*", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(IonItem), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonTextarea), {
                  label: _unref(translate)('Description'),
                  labelPlacement: "floating",
                  modelValue: formData.value.description,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.description) = $event)),
                  maxlength: 255
                }, null, 8, ["label", "modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonFab), {
      vertical: "bottom",
      horizontal: "end",
      slot: "fixed"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonFabButton), {
          disabled: !isGroupUpdated(),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (updateGroup()))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonIcon), { icon: _unref(saveOutline) }, null, 8, ["icon"])
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    })
  ], 64))
}
}

})